import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import EmployeeViewLayer from "../components/EmployeeViewLayer";

const EmployeeViewPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* AdminUserViewLayer */}
                <EmployeeViewLayer />
            </MasterLayout>
        </>
    );
};

export default EmployeeViewPage;
